// extracted by mini-css-extract-plugin
module.exports = {"search":"styles_search__34hwu","search--group":"styles_search--group__2M3Xh","search--input":"styles_search--input__N-aw8","search--icon":"styles_search--icon__1l4d6"};